import { gql } from "@apollo/client";

export const GET_ALL_IPS_DEFICIENCIES = gql`
    query getIpsDeficiencies {
        getIpsDeficiencies {
        typeCode
        typeDesc
        ipsPoints
        ruleName
        reportText
        severity
        lastUpdateDate
        lastUpdateUser
        deactivated
        }
    }
`;

export const GET_DEF_CODES = gql`
    query getUnassignedIpsDeficiencies {
        getUnassignedIpsDeficiencies {
        value
        label
        }
    }
`;

export const GET_ACTIVE_IPS_DEFICIENCIES = gql`
    query getActiveIpsDeficiencies {
        getActiveIpsDeficiencies {
        typeCode
        }
    }
`;


export const ADD_NEW_DEFICIENCY = gql`
    mutation addIpsDeficiency (
        $typeCode: String!
        $ipsPoints: Int!
        $ruleName: String!
        $reportText: String!
        $severity: String!
        $lastUpdateDate: Date!
        $lastUpdateUser: String!
    )
    {
        addIpsDeficiency(
            AddIpsDeficiencyInput: {
            typeCode: $typeCode
            ipsPoints: $ipsPoints
            ruleName: $ruleName
            reportText: $reportText
            severity: $severity
            lastUpdateDate: $lastUpdateDate
            lastUpdateUser: $lastUpdateUser
            }
        ) {
        typeCode
        typeDesc
        ipsPoints
        ruleName
        reportText
        severity
        lastUpdateDate
        lastUpdateUser
        deactivated
        }
    }
`;

export const UPDATE_DEFICIENCY = gql`
    mutation updateIpsDeficiency (
        $typeCode: String!
        $ipsPoints: Int!
        $ruleName: String!
        $reportText: String!
        $lastUpdateDate: Date!
        $lastUpdateUser: String!
    )
    {
        updateIpsDeficiency(
            UpdateIpsDeficiencyInput: {
            typeCode: $typeCode
            ipsPoints: $ipsPoints
            ruleName: $ruleName
            reportText: $reportText
            lastUpdateDate: $lastUpdateDate
            lastUpdateUser: $lastUpdateUser
            }
        ) {
        typeCode
        typeDesc
        ipsPoints
        ruleName
        reportText
        severity
        lastUpdateDate
        lastUpdateUser
        deactivated
        }
    }
`;

export const DEACTIVATE_DEFICIENCY = gql`
    mutation deactivateIpsDeficiency (
        $typeCode: String!
    )
    {
        deactivateIpsDeficiency(
            DeactivateIpsDeficiencyInput: {
            typeCode: $typeCode
            }
        ) {
        typeCode
        typeDesc
        ipsPoints
        ruleName
        reportText
        severity
        lastUpdateDate
        lastUpdateUser
        deactivated
        }
    }
`;

export const ACTIVATE_DEFICIENCY = gql`
    mutation activateIpsDeficiency (
        $typeCode: String!
    )
    {
        activateIpsDeficiency(
            ActivateIpsDeficiencyInput: {
            typeCode: $typeCode
            }
        ) {
        typeCode
        typeDesc
        ipsPoints
        ruleName
        reportText
        severity
        lastUpdateDate
        lastUpdateUser
        deactivated
        }
    }
`;